import { createStore, applyMiddleware ,compose } from "redux";
import rootReducer from "./reducer/allReducer";
import thunk from "redux-thunk";
import logger from 'redux-logger';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
     composeEnhancer(applyMiddleware(thunk,logger))
    
  );
  


export default store;
